/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { get, padStart, trimStart, size, replace } from 'lodash';
import moment from 'moment';

export const EMAIL_REGEX = new RegExp(
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

const Form = ({ onSubmit }) => {
	const [resposta, setResposta] = useState({});
	const [message, setMessage] = useState(null);
	const [submiting, setSubmiting] = useState(false);
	const [errors, setErrors] = useState(null);

	const handleOnChange = e => {
		const { value, name } = e.target;
		let update = true;
		if (['dataNascimento', 'cpf'].indexOf(name) > -1) {
			update = permiteInput(value, name === 'dataNascimento' ? 8 : name === 'cpf' ? 11 : 1);
		}
		if (update) {
			setResposta({ ...resposta, [name]: value });
		}
	};

	const send = () => {
		let errors = { nome: [], dataNascimento: [], cpf: [], email: [] };

		// if (!resposta.nome) {
		// 	errors.nome.push('Nome deve ser informado');
		// } else {
		// 	if (resposta.nome.split(' ').length < 2) {
		// 		errors.nome.push('Informe nome e sobrenome');
		// 	}
		// }

		// if (!resposta.dataNascimento) {
		// 	errors.dataNascimento.push('Data de nascimento deve ser informada');
		// } else {
		// 	if (!moment(resposta.dataNascimento, 'DD/MM/YYYY').isValid()) {
		// 		errors.dataNascimento.push('Data de nascimento inválida');
		// 	}
		// }

		// if (!resposta.cpf) {
		// 	errors.cpf.push('CPF de nascimento deve ser informado');
		// } else {
		// 	if (!isCPF(resposta.cpf)) {
		// 		errors.cpf.push('CPF inválido');
		// 	}
		// }

		// if (!resposta.email) {
		// 	errors.email.push('e-mail deve ser informado');
		// } else {
		// 	if (!EMAIL_REGEX.test(resposta.email)) {
		// 		errors.email.push('email inválido');
		// 	}
		// }

		setErrors(errors);

		const qtd = Object.keys(errors).reduce((acc, k) => acc + errors[k].length, 0);
		if (qtd === 0) {
			onSubmit(resposta);
			setMessage('Resposta enviada com sucesso');
			setSubmiting(true);
			setTimeout(() => {
				setResposta({});
				setMessage(null);
				setSubmiting(false);
			}, 3000);
		}
	};

	const permiteInput = (value, size) => {
		let ok = true;
		const regexStr = `^$|^[0-9]{1,${size}}$`;
		const regex = new RegExp(regexStr);
		ok = regex.test(value);
		return ok;
	};

	const format = (numero, mascara) => {
		const exp = /-|\.|\/|\(|\)|@|%|\$|,| /g;
		const max = mascara.replace(exp, '').length;
		const numeroCompleto = padStart(trimStart((numero || '').toString().replace(exp, ''), '0'), max, '0');
		let size = mascara.length;
		let formatado = '';
		let j = 0;
		for (let i = 0; i < size; i++) {
			if (
				mascara
					.charAt(i)
					.toString()
					.match(exp)
			) {
				formatado += mascara.charAt(i);
				size++;
			} else {
				formatado += numeroCompleto.charAt(j);
				j++;
			}
		}
		return formatado;
	};

	const isCPF = cpf => {
		if (!cpf) return false;
		let soma;
		let resto;
		soma = 0;
		let strCPF = replace(cpf, /(\.|_|-)/g, '');
		if (strCPF === '00000000000' || strCPF.length !== 11) return false;

		for (let i = 1; i <= 9; i++) {
			soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
		}

		resto = (soma * 10) % 11;

		if (resto === 10 || resto === 11) {
			resto = 0;
		}
		if (resto !== parseInt(strCPF.substring(9, 10))) {
			return false;
		}
		soma = 0;
		for (let i = 1; i <= 10; i++) {
			soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
		}
		resto = (soma * 10) % 11;

		if (resto === 10 || resto === 11) resto = 0;
		if (resto !== parseInt(strCPF.substring(10, 11))) return false;
		return true;
	};

	return (
		<div className="formulario-resposta">
			<p className="titulo-form">Opcionalmente, informe seus dados e clique em “enviar minha tarifa”</p>
			<p className="subtitulo-form">A equipe responsável irá guardar suas respostas para fins estatísticos.</p>
			<div className="grid-form">
				<div className="form-linha">
					<label>Nome</label>
					<input
						type="text"
						className="form-control"
						id="nome"
						name="nome"
						placeholder="Nome Sobrenome"
						value={resposta.nome || ''}
						onChange={handleOnChange}
						disabled={submiting}
					></input>
					{size(get(errors, 'nome')) > 0 &&
						errors.nome.map((e, i) => (
							<span className="error-message" key={i}>
								{e}
							</span>
						))}
				</div>
				<div className="form-linha">
					<label>Data de nascimento</label>
					<input
						type="text"
						className="form-control"
						id="datanascimento"
						name="dataNascimento"
						placeholder="dd/mm/aaaa"
						value={resposta.dataNascimento || ''}
						onBlur={() => setResposta({ ...resposta, dataNascimento: format(resposta.dataNascimento, '00/00/0000') })}
						onChange={handleOnChange}
						disabled={submiting}
					></input>
					{size(get(errors, 'dataNascimento')) > 0 &&
						errors.dataNascimento.map((e, i) => (
							<span className="error-message" key={i}>
								{e}
							</span>
						))}
				</div>
			</div>
			<div className="grid-form">
				<div className="form-linha">
					<label>CPF</label>
					<input
						type="text"
						className="form-control"
						id="cpf"
						name="cpf"
						placeholder="000.000.000-00"
						value={resposta.cpf || ''}
						onBlur={() => setResposta({ ...resposta, cpf: format(resposta.cpf, '000.000.000-00') })}
						onChange={handleOnChange}
						disabled={submiting}
					></input>
					{size(get(errors, 'cpf')) > 0 &&
						errors.cpf.map((e, i) => (
							<span className="error-message" key={i}>
								{e}
							</span>
						))}
				</div>
				<div className="form-linha">
					<label>E-mail</label>
					<input
						type="text"
						className="form-control"
						id="email"
						name="email"
						placeholder="seunome@email.com.br"
						value={resposta.email || ''}
						onChange={handleOnChange}
						disabled={submiting}
					></input>
					{size(get(errors, 'email')) > 0 &&
						errors.email.map((e, i) => (
							<span className="error-message" key={i}>
								{e}
							</span>
						))}
				</div>
			</div>

			<button
				className={`btn ${submiting ? 'btn-disabled' : 'btn-primary'}`}
				type="button"
				value="Enviar minha tarifa"
				onClick={send}
				disabled={submiting}
			>
				Enviar minha tarifa
			</button>

			{message && <div className="alert alert-success message">{message}</div>}
		</div>
	);
};
Form.displayName = 'Form';
Form.propTypes = {
	onSubmit: PropTypes.func
};
export default Form;
